import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { fetchUtility } from '../../api/api';
import type { GetUsageComponentProps } from '../../types';
import { LoadingRow } from '../loading-row';
import { ShowUsage } from './show_usage';
import { SmtGetInfo } from './via_smt/get_info';
import { SmtShowAgreement } from './via_smt/show_agreement';
import { useUpdateEffect } from '../../common/hooks/myHooks';

enum PageView {
    SOURCE,
    SMTINFO,
    SMTAGREEMENT,
    TDUINFO,
    MYACCOUNTINFO,
    USAGE
}

export const GetUsageComponent: React.FC<GetUsageComponentProps> = ({
    handleSetConsentId,
    defaultView,
    inModal,
    zipcode,
    handleClose,
    forcastUsage
}) => {
    const navigate = useNavigate();
    const [view, setView] = useState(PageView.SMTINFO);
    const [consentId, setConsentId] = useState('');
    const [email, setEmail] = useState('');
    const [recommend, setRecommend] = useState('');
    const [usage, setUsage] = useState([]);
    const [unusualMonth, setUnusualMonth] = useState<string[]>([]);
    const [isPredictedData, setIsPredictedData] = useState(false);
    const sourceFrom = useRef('');

    useUpdateEffect(() => {
        if (!zipcode) {
            return
        }
        if (zipcode) {
            fetchUtility(zipcode).then(res => {
                if (res) {
                    const isOncor = res[0].utility_name.toLowerCase().indexOf('oncor') >= 0;
                    setRecommend(isOncor ? 'smt' : 'tdu');
                }
            })
        }
    }, [zipcode])

    const getView = () => {
        switch (view) {
            case PageView.SOURCE:
                return <UsageSource
                    handleClick={() => {
                        setView(PageView.SMTINFO);
                    }}
                    recommend={recommend}
                />;
            case PageView.SMTINFO:
                return <SmtGetInfo
                    handleShowAgreement={(concentId: string, email: string) => {
                        setConsentId(concentId);
                        setEmail(email);
                        setView(PageView.SMTAGREEMENT);
                        handleSetConsentId(concentId);
                    }}
                    handleBack={() => {
                        handleClose && handleClose();
                        console.log('SmtGetInfo')
                    }}
                    hideBack={(inModal && defaultView) ? true : false}
                />;
            case PageView.SMTAGREEMENT:
                return <SmtShowAgreement
                    consentId={consentId}
                    handleBack={
                        () => setView(PageView.SMTINFO)
                    }
                    email={email}
                    handleSetUsage={(data: any) => {
                        setUsage(data);
                        sourceFrom.current = 'smt';
                        setView(PageView.USAGE);
                        setIsPredictedData(false);
                    }}
                    handleSetUnusualMonth={(data: string[]) => setUnusualMonth(data)}
                />;
            case PageView.USAGE:
                return <ShowUsage
                    source={sourceFrom.current}
                    data={usage}
                    unusualMonth={unusualMonth}
                    isPredictedData={isPredictedData}
                    showSmtView={() => {
                        setView(PageView.SMTINFO);
                    }}
                    showMyaccountView={() => {
                        setView(PageView.MYACCOUNTINFO);
                    }}
                    handleBack={() => {
                        handleClose && handleClose();
                        console.log('SmtGetInfo')
                    }}
                />
            default: return null;
        }
    }

    return (
        <div style={{ margin: '-30px 0' }}>
            {getView()}
        </div>
    )
}

const UsageSource = ({ handleClick, recommend }: {
    handleClick: (type: string) => void,
    recommend: string
}) => {
    const { t } = useTranslation('usage');
    return (
        <div>
            <h2 className="mb-4">{t('Pick Your Way to Get Usage Data')}</h2>
            {
                !recommend &&
                <div className="pt-5 pb-5"><LoadingRow /></div>
            }
            {
                recommend &&
                <div id="get-usage-option-wrapper">
                    {
                        recommend === 'tdu' &&
                        <div className="get-usage-option recommend" onClick={() => { handleClick('tdu') }}>
                            <div>
                                <h5>{t('Retrieve My Actual Usage')}</h5>
                                <p>{t('Quickest way to pull usage pattern from your utility account')}</p>
                            </div>
                            <i>{t('Recommend')}</i>
                        </div>
                    }
                    <div className={`get-usage-option ${recommend === 'smt' ? 'recommend' : ''}`} onClick={() => { handleClick('myaccount') }}>
                        <div>
                            <h5>{t('MyAccount')}</h5>
                            <p>{t('Instant access of your usage history through MyAccount')}</p>
                        </div>
                        {recommend === 'smt' && <i>{t('Recommend')}</i>}
                    </div>
                    <div className="get-usage-option" onClick={() => { handleClick('smt') }}>
                        <div>
                            <h5>{t('Use Smart Meter Texas (SMT) Data')}</h5>
                            <p>{t('Instant access of your usage history through your smart meter number')}</p>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}